import React from "react";
import { useSetUser, useUser } from "../context/userContext.js";
import { logout, removerequest } from "../api/axios.js";
import PopUp from "./CreateNewPost.js";
import { addFollower, followrequest } from "./../api/axios";
import { useNavigate } from "react-router-dom";

//custom nav item which takes name ,icon and function to be executed
const Item = ({ name, icon, fun, hidden, setHidden, newNoti = false }) => {
  return (
    <>
      <div
        className="py-5 pr-10 pl-5 rounded-lg  hover:bg-gray-100 cursor-pointer flex gap-8 text-lg  items-center"
        onClick={() => {
          setHidden(false);
          fun();
        }}
      >
        {newNoti ? (
          <div className="dot-container">
            <div className="dot"></div>
            <i className={icon} aria-hidden="true"></i>
          </div>
        ) : (
          <i className={icon} aria-hidden="true"></i>
        )}
        <div className={`hidden  ${hidden ? "hidden" : "sm:block"}`}>
          {name}
        </div>
      </div>
    </>
  );
};

const SideBar = (props) => {
  const user = useUser();

  const setUser = useSetUser();
  const [hidden, setHidden] = React.useState(false);
  
  const navigate = useNavigate();

  return (
    <div className="flex">
      <div className="fixed bottom-0 sm:relative  flex-col-reverse sm:flex-row flex  bg-white ">
        {/* for creation of post */}
        <div
          className={`flex justify-center sm:justify-start capitalize sm:flex-col sm:flex  shadow-lg ${
            hidden ? "" : " w-full"
          } `}
        >
          {hidden && (
            <Item
              key={"bars"}
              icon={"fa fa-bars"}
              name="home"
              fun={() => {
                setHidden(false);
              }}
              hidden={hidden}
              setHidden={setHidden}
            />
          )}

          <Item
            key={"dashboard"}
            icon={"fa fa-home"}
            name="home"
            fun={() => {
              navigate("/");
            }}
            hidden={hidden}
            setHidden={setHidden}
          />
          <Item
            key={"annoucements"}
            icon={"fa fa-bullhorn"}
            name="Announcements"
            fun={() => {
              navigate("/Annoucements");
            }}
            hidden={hidden}
            setHidden={setHidden}
          />

          <Item
            key={"create"}
            icon={"fa fa-plus-square"}
            name="add project"
            fun={() => {
              navigate("/create");
            }}
            hidden={hidden}
            setHidden={setHidden}
          />
          <Item
            key={"createResource"}
            icon={"fa fa-plus-square"}
            name="add resource"
            fun={() => {
              navigate("/createResource");
            }}
            hidden={hidden}
            setHidden={setHidden}
          />
          <Item
            key={"profile"}
            icon={"fa fa-home "}
            name="profile"
            fun={() => {
              navigate(`/${user.user.usn}`);
            }}
            hidden={hidden}
            setHidden={setHidden}
          />
          <Item
            key={"logout"}
            icon={"fa fa-sign-out"}
            name="logout"
            fun={() => {
              localStorage.removeItem("refreshToken");
              setUser(null);
              navigate("/login");
            }}
            hidden={hidden}
            setHidden={setHidden}
          />
        </div>
      </div>

      {props.children}
    </div>
  );
};

export default SideBar;
